import { memo, PropsWithChildren } from 'react';

import Debug from '@/components/Debug/Debug';
import hiddenTimelineEvents from '@/constants/hiddenTimelineEvents';
import { TimelineSubcomponentProps } from '@/pages/Timeline/types';

const TimelineItemWrapper = ({
  activityLog,
  children
}: PropsWithChildren<TimelineSubcomponentProps>) => {
  return (
    <div data-testid={`timeline-item-${activityLog.id}`}>
      <div className="relative">
        {children}
        {activityLog.action && !hiddenTimelineEvents.includes(activityLog.action) && (
          <Debug object={activityLog} buttonClassName="absolute bottom-5 right-0.5" />
        )}
      </div>
    </div>
  );
};

export default memo(TimelineItemWrapper);
